import styled from 'styled-components';
import { palette } from '@dev/ee-components';

export const ScreenshotWrapper = styled.div`
    width: 690px;
    max-width: 100%;
    height: 352px;
    border-radius: 20px;
    border: 1px solid ${palette.gray[3]};
    position: relative;
    background-color: #fff;
    overflow: hidden;
    margin-bottom: 12px;
    img {
        width: 100%;
        height: 100%;
        border-radius: 20px;
        object-fit: contain;
    }
    svg {
        position: relative;
        top: -50px;
    }
`;

export const TemplateButtonsWrapper = styled.div`
    display: flex;
    gap: 20px;
    justify-content: space-between;
    margin-bottom: 32px;
    margin-left: 6px;
`;
